import React from "react";
import { FullAddress } from "../FullAddress";
import { FieldDisplayOptions } from "./getCustomFieldValue";
import { ParsedPhoneNumber } from "../../components/global_components/form_components/ControlledPhoneNumber";

interface IInputLookupParams {
  options?: FieldDisplayOptions;
  value?: any;
}

const inputLookup = {
  Address: ({ value, options }: IInputLookupParams) => {
    if (!value) return null;
    const showFlag = !!options?.agencyCountry && value?.countryId !== options.agencyCountry;
    return (
      <FullAddress
        address={value?.address}
        address2={value?.address2}
        city={value?.city}
        state={value?.state}
        zip={value?.zip}
        attn={value?.attn}
        countryId={showFlag ? value?.countryId : null}
      />
    );
  },
  Checkbox: ({ value }: IInputLookupParams) => {
    if (value === null) return null;
    return value ? "Yes" : "No";
  },
  Currency: ({ value }: IInputLookupParams) => (value ? "$" + (value / 100).toFixed(2) : null),
  Date: ({ value }: IInputLookupParams) =>
    value?.toLocaleDateString("en-us", {
      month: "short",
      year: "numeric",
      day: "numeric",
    }),
  DateTime: ({ value }: IInputLookupParams) =>
    value?.toLocaleDateString("en-us", {
      month: "short",
      year: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    }),
  Dropdown: ({ value }: IInputLookupParams) => value,
  DropdownMultiSelect: ({ value }: IInputLookupParams) =>
    value
      ?.map((value: any) => {
        return value.corePicklistItem.value;
      })
      .join(" • "),
  Email: ({ value }: IInputLookupParams) => value,
  Number: ({ value }: IInputLookupParams) => value,
  Percent: ({ value }: IInputLookupParams) => value,
  PhoneNumber: ({ value }: IInputLookupParams) => <ParsedPhoneNumber value={value} />,
  Text: ({ value }: IInputLookupParams) => value,
  // If text area exceeds length limit, crop and append "..."
  TextArea: ({ value }: IInputLookupParams) =>
    value ? value?.substring(0, 50) + (value?.length === value?.substring(0, 50).length ? "" : "...") : null,
  Time: ({ value }: IInputLookupParams) =>
    value?.toLocaleTimeString("en-us", {
      hour: "numeric",
      minute: "2-digit",
    }),
  URL: ({ value }: IInputLookupParams) => value,
  LookUp: () => null, //TODO: Implement this
};

export function StandardFieldValue({
  value,
  type,
  nullReplacement = "--",
  options,
}: {
  value: any;
  type: keyof typeof inputLookup;
  nullReplacement?: string;
  options?: FieldDisplayOptions;
}): JSX.Element {
  const lookUpResult = inputLookup[type];
  if (!lookUpResult) return <span>{nullReplacement}</span>;
  const displayValue = lookUpResult({ options, value }) ?? nullReplacement;
  if (typeof displayValue === "string") {
    return <span>{displayValue}</span>;
  }
  return displayValue;
}
